import { createSelector } from '@reduxjs/toolkit';
import { getOrganization } from './getOrganization';

export const getIsInternalOrganization = createSelector(getOrganization, function (organization): boolean {
  if (organization === undefined) return false;
  return organization.ownerEmail.endsWith('@trinnvis.no') || organization.ownerEmail.endsWith('@mailinator.com');
});
